export default __webpack_public_path__ + "static/media/feraye6.545afe90.jpg";